import * as types from '@/store/types'
import UnitOfWorkService from '@/services/UnitOfWorkService'
// import router from '@/router/index'
import ability from '@/plugins/abilityPlugIn'
import defineAbilitiesFor from '@/plugins/ability'
import jwtManager from '@/store/jwtManager'

const state = {
    token: jwtManager.getJwt()
}

const getters = {
    username: () => jwtManager.getJwtSubject(),
    isAuthenticated: state => !!state.token
}

const actions = {
    [types.AUTH_LOGIN]({
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            new UnitOfWorkService().authService().login(payload).then(resp => {
                    commit(types.AUTH_LOGIN, resp.data)
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    [types.AUTH_LOGOUT]({
        commit
    }) {
        commit('logout')
    },
    [types.AUTH_REGISTRATION]({
            commit
        },
        payload) {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            new UnitOfWorkService().authService().registration(payload).then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    [types.AUTH_FORGOT_PASSWORD]({
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            new UnitOfWorkService().authService().forgotPassword(payload).then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    [types.AUTH_RESET_PASSWORD]({
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            new UnitOfWorkService().authService().resetPassword(payload).then(resp => {
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    checkAuthentification({
        commit
    }) {
        if (jwtManager.getJwt() == null || jwtManager.jwtExpired() == true) {
            commit('logout')
            return
        }

        return new Promise((resolve, reject) => {
            new UnitOfWorkService().authService().authorized().then(() => {
                    ability.update(defineAbilitiesFor(jwtManager.getJwtRoles()))
                    resolve()
                })
                .catch(err => {
                    commit('logout')
                    reject(err)
                })
        })
    }
}

const mutations = {
    [types.AUTH_LOGIN](state, jwt) {
        jwtManager.setJwt(jwt)
        state.token = jwt
        ability.update(defineAbilitiesFor(jwtManager.getJwtRoles()))
    },
    logout() {
        jwtManager.removeJwt()
        state.token = null
        ability.update(defineAbilitiesFor(''))
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}